// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing175({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/175/01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/175/02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/175/03.gif`}
      formFieldColor="white"
      qTitleColor="#0202bc"
      qOptionColor="blue"
      privacyMessage="개인정보수집에 동의하시는 분만 '비용 확인하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costCheckButton2.png`}
      companyName="청춘플란트치과의원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_footer.jpg`}
      eventDates={true}
      carrotTag={true}
    />
  );
}

export default Randing175;
